class Product {
    constructor() {
        if (document.querySelector(".product")) {
            this.defaultPrice = document.querySelector(".product-price__price span");
            this.promoPrice = document.querySelector(".product-price__price-promo span");
            this.ecopartPrice = document.querySelector(".product-price__ecopart span");

            this.initSingle();
        }
        this.initFilters();

        if (!document.querySelector(".single-product")) return;

        this.popup = document.querySelector(".slider__popup");
        this.close = this.popup.querySelector(".close");
        this.slider = document.querySelector(".block-slider");
        this.img = null;

        this.initSliderPopup();
    }

    initSingle() {
        Array.from(document.querySelectorAll(".product__places-selector")).forEach((item) => {
            item.addEventListener("click", () => {
                const price = item.dataset;

                const oldActive = document.querySelector(".product__places-selector.active");
                if (oldActive) oldActive.classList.remove("active");
                item.classList.add("active");

                const { defaultPrice, promoPrice, ecopartPrice } = this;

                if (defaultPrice) {
                    defaultPrice.innerHTML = price.old !== undefined ? price.old : price.global;
                }

                if (price.old !== undefined) {
                    defaultPrice.parentElement.classList.remove("product-price__price");
                    defaultPrice.parentElement.classList.add("product-price__price-old");
                    promoPrice.innerHTML = price.global;
                    promoPrice.parentNode.parentElement.style.display = "block";
                } else {
                    defaultPrice.parentElement.classList.remove("product-price__price-old");
                    defaultPrice.parentElement.classList.add("product-price__price");
                    promoPrice.innerHTML = "";
                    promoPrice.parentNode.parentElement.style.display = "none";
                }

                if (ecopartPrice) ecopartPrice.innerHTML = price.ecopart;
            });
        });
    }

    //  eslint-disable-next-line
    initFilters() {
        const filtersMenu = document.querySelector(".filters-menu");
        if (filtersMenu && !filtersMenu.children.length) {
            document.querySelector(".filters").style.display = "none";
            document.querySelector(".filters-mobile").style.display = "none";
        }
    }

    initSliderPopup() {
        this.slider.addEventListener("click", ({ target }) => {
            if (target.tagName !== "IMG") return;

            this.img = Product.buildImage(target.src);
            this.popup.append(this.img);
            this.popup.classList.add("active");
        });

        this.close.addEventListener("click", () => {
            this.closePopup();
        });

        window.addEventListener("keydown", ({ key }) => {
            if (key !== "Escape") return;
            this.closePopup();
        });
    }

    static buildImage(src) {
        const img = document.createElement("img");
        img.src = src;

        return img;
    }

    closePopup() {
        this.popup.classList.remove("active");
        if (this.img) this.img.remove();
    }
}

export default Product;
